import { PRACTICE, ITEMS } from '../constants/assessmentItemType';

export const getRANItems = (state, pageType) => {
    let content;
    switch (pageType) {
    case PRACTICE:
        content = state.practice;
        break;
    case ITEMS:
        content = state.items;
        break;
    default:
        content = [{}];
    }
    return content;
};

export const getIsRANDataFetched = (state) => state.isDataFetched;

export const getRANActiveItemIndex = (state) => state.activeItemIndex;

export const getRANResponses = (state) => state.selectedResponses;

export const getRANFormId = (state) => state.formId;

export const getRANTimeDuration = (state) => state.timeDuration;
